const VARIANTS = [{a:-4.9,b:14.7,ground:3,vertex:1.5},{a:-5,b:20,ground:4,vertex:2},{a:-4,b:16,ground:4,vertex:2},{a:-3,b:15,ground:5,vertex:2.5},{a:-6,b:18,ground:3,vertex:1.5},{a:-2,b:12,ground:6,vertex:3},{a:-5,b:15,ground:3,vertex:1.5},{a:-4,b:20,ground:5,vertex:2.5}];

export function getProjectileData(original) {
  return original ? VARIANTS[0] : VARIANTS[Math.floor(Math.random() * VARIANTS.length)];
}
